import React from 'react';

import { LiveSearchLoader } from '@confluence/live-search/entry-points/liveSearchLoader';
import {
	getExperienceName,
	getMacroAttributesFromADFNode,
	MacroExperienceSuccess,
} from '@confluence/macro-tracker';
import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/fabric-extension-lib-types';
import { extensionToADF } from '@confluence/fabric-extension-lib/entry-points/editor-extensions';

type LiveSearchHandlerProps = {
	macroDefaultProps: ExtensionHandlerProps;
};

export const LiveSearchHandler = ({ macroDefaultProps }: LiveSearchHandlerProps) => {
	const { contentId, extensionKey, node, mode } = macroDefaultProps;
	const attributes = getMacroAttributesFromADFNode(node);

	return (
		<>
			<LiveSearchLoader macroNode={extensionToADF(node)} />
			<MacroExperienceSuccess
				name={getExperienceName(mode, node)}
				contentId={contentId}
				extensionKey={extensionKey}
				mode={mode}
				attributes={attributes}
			/>
		</>
	);
};
